import { render } from "./FormFloorView.vue?vue&type=template&id=729b1af4"
import script from "./FormFloorView.vue?vue&type=script&lang=js"
export * from "./FormFloorView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__